// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class SubscribeMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_SUBSCRIBE_MESSAGE, fieldSet);
    }
    getSubscriptionAction() {
        return this.getFieldValue(FieldsFactory.FIELD_SUBSCRIPTION_ACTION);
    }
    setSubscriptionAction(type) {
        this.setFieldValue(FieldsFactory.FIELD_SUBSCRIPTION_ACTION, type);
    }
}
